$('a.parent_link_b').click(function() {
  $('li.child_link').removeClass('active');
  $(this).parent('.child_link').addClass('active');
});

$('.site-header__menu-toggle').click(function() {
  $('ul.menu.menu-bar').addClass('active');
});

$('.menu-bar-link.parent_link_a').click(function() {
  $('.menu-bar-link.parent_link_a').removeClass('active');
  $(this).addClass('active');
});

$('a.menu-link.mega-menu-link.parent_link_b').click(function() {
  $('a.menu-link.mega-menu-link.parent_link_b').removeClass('active');
  $('.parent_link-back').show();
  $('.parent_link_a').hide();
  $(this).addClass('active');
});
$('.parent_link-back').click(function() {
  $('a.menu-link.mega-menu-link.parent_link_b').removeClass('active');
  $('.parent_link-back').hide();
  $('.parent_link_a').show();
});

$('.mega-menu__back-btn').click(function() {
  $('body').removeClass('mobile-help-menu');
});

$(window).scroll(function() {
  var distance = 0;
  if ($('#shopify-section-homepage-layout h1.h1').length > 0) {
    distance = $('#shopify-section-homepage-layout h1.h1').offset().top;
  }
  var distance2 = 0;
  if ($('#PageContainer').length > 0) {
    distance2 = $('#PageContainer').offset().top;
  }
  var $window = $(window);
    if ($window.scrollTop() > distance) {
      $('body').addClass('fixed-header-index');
    } else {
      $('body').removeClass('fixed-header-index');
    }
  
    if ($window.scrollTop() > distance2) {
      $('body').addClass('opfix');
    } else {
      $('body').removeClass('opfix');
    }
});

$('.shop-nav a.site-nav__link').click(function(e) {
  setTimeout(() => {
    $('.uppermenu li.lnk').removeClass('active');
    $('.uppermenu li.lnk[atr="shop"]').addClass('active')
    $('.new-brand-menu').hide();
    $('.new-shop-menu').fadeIn();  
  }, 50);
});

$('.brand-nav a.site-nav__link').click(function(e) {
  setTimeout(() => {
    $('.uppermenu li.lnk').removeClass('active');
    $('.uppermenu li.lnk[atr="brand"]').addClass('active');
    $('.new-brand-menu').fadeIn();
    $('.new-shop-menu').hide();  
  }, 50);
});

$('.uppermenu li.lnk').click(function(e) {
  setTimeout(() => {
    $('.uppermenu li.lnk').removeClass('active');
    $(this).addClass('active');
    var at = $(this).attr('atr');
    if (at == 'shop') {
      $('.new-shop-menu').fadeIn();
      $('.new-brand-menu').hide();
    } else if (at == 'brand') {
      $('.new-brand-menu').fadeIn();
      $('.new-shop-menu').hide();          
    }
  }, 100);
});

$(document).on('click', '.helpclick',function() {
  $('body').addClass('mobile-help-menu');
});

$('.helpclick').hover(function() {
  $('body').addClass('mobile-help-menu');
});

$('.first-view').hover(function() {
  $('body').removeClass('mobile-help-menu');
});
